var _Path, _Path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.182 5.914c-.887 1.07-2.515 1.846-3.542 2.171.161-1.018.67-2.674 1.595-3.788.797-.96 1.344-1.214 1.718-1.214.29 0 .477.154.593.251.26.217 1.053.875-.364 2.58Zm-9.843 0c-1.417-1.705-.625-2.364-.364-2.58.268-.222.894-.742 2.311.963.925 1.114 1.434 2.77 1.596 3.788-1.027-.325-2.655-1.102-3.543-2.171Zm10.377 3.062a8.033 8.033 0 0 0 1.506-1.367c2.296-2.765 1.445-5.13.018-6.315-.689-.571-3.159-2.167-6.045 1.308a8.514 8.514 0 0 0-.935 1.433 8.516 8.516 0 0 0-.934-1.433C9.438-.873 6.968.722 6.28 1.294c-1.427 1.185-2.278 3.55.018 6.315.418.503.94.961 1.506 1.367H0v6.304h12.199V8.976h2.122v6.304H26.52V8.976h-7.804ZM14.503 29.435h10.774V17.004H14.503v12.431ZM1.203 29.431h10.774V17H1.203v12.431Z",
    fill: "currentColor"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.466 18.661H25.24v-1.657H14.466v1.657ZM1.205 18.661H11.98v-1.657H1.205v1.657Z",
    fill: "currentColor"
  })));
};
export default SvgGift;